var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"2rem","height":"2rem","line-height":"2rem","text-align":"center","background-color":"#ff7c2c","color":"#FFFFFF","margin":"0 auto"},on:{"click":_vm.clear}},[_c('span',[_vm._v("清除缓存")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78164be2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/timetable/test.vue
// module id = null
// module chunks = 